import { Link2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { BoxIcon } from '@/Domain/components/Shared/BoxIcon/BoxIcon';
import { TableCell, TableRow } from '@/Domain/components/Shared/Table/Table';

export const InactiveLinkTrackingTableRow = () => {
  const { t } = useTranslation('insights_page', { keyPrefix: 'ai_insights.link_tracking' });

  return (
    <TableRow className="hover:!bg-transparent mx-auto border-b-0">
      <TableCell colSpan={4} className="text-center space-y-2 py-12 text-sm text-foreground-subtle">
        <BoxIcon variant="outlined" className="mx-auto">
          <Link2 className="size-4 text-foreground-subtle" />
        </BoxIcon>
        <p className="font-semibold">{t('enable')}</p>
        <p className="text-xs text-foreground-subtle">{t('link_tracking_disabled')}</p>
      </TableCell>
    </TableRow>
  );
};
